'use strict';

var path = require('path'); // Make sure the given address has '/_access' as the last part


var ensureAddress = function ensureAddress(address) {
  var suffix = address.toString().split('/').pop();
  return suffix === '_access' ? address : path.join(address, '/_access');
};

module.exports = ensureAddress;